import useSWR from 'swr';

import myShopClient from '@services/nearlive';

import { useShop } from './useShop';

/**
 * Local Potential Score (NEA-5765) — a thin SWR fetch of the backend resolver
 * (`GET /api/local-potential/{shopId}`), mirroring `useBillingStatus`. The score,
 * its per-item breakdown, suggestions and quick wins are all computed server-side
 * by the one pure model, so the dashboard, comms and any future consumer can
 * never disagree. The client-side maths the NEA-5689 placeholder carried is gone.
 *
 * Returns the resolver response spread onto the result (so callers can read
 * `.score`, `.groups`, `.suggestions`, `.quickWins` directly) plus `data` (the
 * whole response), `error`, `isLoading` and `mutate` (used for optimistic gauge
 * bumps and cross-hook invalidation under the `['local-potential', shopId]` key).
 */
export function useLocalPotential(shopId) {
	const { shop } = useShop();
	const id = shopId ?? shop?.id;
	const key = id ? ['local-potential', id] : null;
	const { data, error, isLoading, mutate } = useSWR(
		key,
		async () => {
			const client = await myShopClient();
			const { data } = await client.get(`/api/local-potential/${id}`);
			return data;
		},
		{ revalidateOnFocus: false }
	);
	return { ...(data || {}), data: data ?? null, error, isLoading, mutate };
}
